// FitMar product descriptions (".fm-desc" blocks): the founder note on FitMar products, the composition
// as a list, a subtle fade-in for blocks that are still below the fold, and no empty frame for a photo
// that fails to load. The description never depends on this script: without it every block is simply
// visible. Numbers, bars and the nutrition table are static (see snippets/tab-content-description.liquid).
(function () {
  // The description snippet and older templates may both include this file
  if (window.FitMarDescriptions) return;

  var REVEAL_CLASS = "fm-reveal";
  var REVEAL_ATTR = "data-fm-watched";
  var PHOTOS_ATTR = "data-fm-photos";

  function getScopedElements(root, selector) {
    var scope = root || document;
    var elements = [];

    if (scope.nodeType === 1 && scope.matches && scope.matches(selector)) {
      elements.push(scope);
    }

    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll(selector), function (el) {
        elements.push(el);
      });
    }

    return elements;
  }

  // --- Founder banner injection (FitMar brand products only) ---
  function isFitMarProduct() {
    var vendor = "";
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        vendor = window.ShopifyAnalytics.meta.product.vendor || "";
      }
    } catch (e) {}
    if (!vendor && window.meta && window.meta.product) {
      vendor = window.meta.product.vendor || "";
    }
    if (!vendor) {
      var og = document.querySelector('meta[property="og:brand"]');
      if (og) vendor = og.getAttribute("content") || "";
    }
    return vendor.toLowerCase().indexOf("fitmar") !== -1;
  }

  var FOUNDER_TRANSLATIONS = {
    cs: {
      quote: "„Do FitMaru vybírám jen to, co má poctivé složení a fakt dobře chutná.“",
      role: "zakladatel FitMar",
      alt: "Martin Klusák, zakladatel FitMar"
    },
    sk: {
      quote: "„Do FitMaru vyberám len to, čo má poctivé zloženie a naozaj dobre chutí.“",
      role: "zakladateľ FitMar",
      alt: "Martin Klusák, zakladateľ FitMar"
    },
    hu: {
      quote: "„A FitMarba csak olyan termékeket válogatok, amelyek összetétele tiszta, és az ízük igazán finom.“",
      role: "a FitMar alapítója",
      alt: "Martin Klusák, a FitMar alapítója"
    },
    pl: {
      quote: "„Do FitMaru wybieram tylko produkty z uczciwym składem, które naprawdę dobrze smakują.“",
      role: "założyciel FitMar",
      alt: "Martin Klusák, założyciel FitMar"
    },
    ro: {
      quote: "„Pentru FitMar aleg doar produse cu ingrediente curate și gust cu adevărat bun.“",
      role: "fondatorul FitMar",
      alt: "Martin Klusák, fondatorul FitMar"
    },
    nl: {
      quote: "„Voor FitMar selecteer ik alleen producten met eerlijke ingrediënten die echt goed smaken.”",
      role: "oprichter van FitMar",
      alt: "Martin Klusák, oprichter van FitMar"
    },
    sl: {
      quote: "„Za FitMar izbiram le izdelke s pošteno sestavo, ki so res dobrega okusa.“",
      role: "ustanovitelj FitMar",
      alt: "Martin Klusák, ustanovitelj FitMar"
    },
    de: {
      quote: "„Für FitMar wähle ich nur Produkte mit ehrlichen Zutaten aus, die wirklich gut schmecken.“",
      role: "Gründer von FitMar",
      alt: "Martin Klusák, Gründer von FitMar"
    }
  };

  var FOUNDER_DOMAIN_LOCALES = {
    "fitmar.cz": "cs",
    "www.fitmar.cz": "cs",
    "fitmar.sk": "sk",
    "www.fitmar.sk": "sk",
    "fitmar.hu": "hu",
    "www.fitmar.hu": "hu",
    "fitmar.pl": "pl",
    "www.fitmar.pl": "pl",
    "fitmar.ro": "ro",
    "www.fitmar.ro": "ro",
    "fitmar.be": "nl",
    "www.fitmar.be": "nl",
    "fitmar.nl": "nl",
    "www.fitmar.nl": "nl",
    "fitmar.si": "sl",
    "www.fitmar.si": "sl",
    "fitmarshop.de": "de",
    "www.fitmarshop.de": "de",
    "fitmar.ch": "de",
    "www.fitmar.ch": "de",
    "fitmar.at": "de",
    "www.fitmar.at": "de"
  };

  function getFounderLocale() {
    var host = (window.location.hostname || "").toLowerCase();
    var domainLocale = FOUNDER_DOMAIN_LOCALES[host];
    if (domainLocale) return domainLocale;

    var pageLocale = "";
    if (document.documentElement) {
      pageLocale = document.documentElement.getAttribute("lang") || "";
    }
    pageLocale = pageLocale.toLowerCase().split("-")[0];
    if (FOUNDER_TRANSLATIONS[pageLocale]) return pageLocale;

    return "cs";
  }

  function localizeFounderBanner(section) {
    var t = FOUNDER_TRANSLATIONS[getFounderLocale()] || FOUNDER_TRANSLATIONS.cs;
    var quote = section.querySelector(".fm-founder__quote");
    var role = section.querySelector(".fm-founder__signature span");
    var image = section.querySelector(".fm-founder__photo img");

    if (quote) quote.textContent = t.quote;
    if (role) role.textContent = t.role;
    if (image) image.alt = t.alt;
  }

  function buildFounderBanner() {
    var t = FOUNDER_TRANSLATIONS[getFounderLocale()] || FOUNDER_TRANSLATIONS.cs;

    var section = document.createElement("section");
    section.className = "fm-founder fm-animate";

    var photoWrap = document.createElement("div");
    photoWrap.className = "fm-founder__photo";
    var img = document.createElement("img");
    img.loading = "lazy";
    img.decoding = "async";
    img.width = 96;
    img.height = 96;
    img.src = "https://popisky.fitmar.cz/martin.webp";
    img.alt = t.alt;
    photoWrap.appendChild(img);

    var content = document.createElement("div");
    content.className = "fm-founder__content";

    var quote = document.createElement("blockquote");
    quote.className = "fm-founder__quote";
    quote.textContent = t.quote;
    content.appendChild(quote);

    var sig = document.createElement("div");
    sig.className = "fm-founder__signature";
    var nameEl = document.createElement("strong");
    nameEl.textContent = "Martin Klusák";
    var roleEl = document.createElement("span");
    roleEl.textContent = t.role;
    sig.appendChild(nameEl);
    sig.appendChild(roleEl);
    content.appendChild(sig);

    section.appendChild(photoWrap);
    section.appendChild(content);
    return section;
  }

  function injectFounderBanner() {
    if (!isFitMarProduct()) return;
    var existingBanner = document.querySelector(".fm-founder");
    if (existingBanner) {
      localizeFounderBanner(existingBanner);
      return;
    }

    var desc = document.querySelector(".fm-desc");
    if (!desc) return;

    var children = [];
    for (var i = 0; i < desc.children.length; i++) {
      var el = desc.children[i];
      if (el.tagName === "SECTION" || el.tagName === "FIGURE") children.push(el);
    }

    var banner = buildFounderBanner();
    if (children.length === 0) {
      desc.appendChild(banner);
    } else {
      var midpoint = Math.floor(children.length / 2);
      desc.insertBefore(banner, children[midpoint]);
    }
  }

  // --- Composition as a list ---
  // The composition is one long sentence: "32 % kešu pražené nasucho, 25 % bílá čokoláda (cukr, kakaové
  // máslo, …), 10 % kokosový olej." As a list it reads at a glance: a row per ingredient with its share at
  // the right edge and what it is made of (the brackets at its end) muted under it. Commas inside brackets
  // stay with their ingredient, a decimal comma ("12,5 %") is no separator, and the bold allergens keep
  // their markup. The sentence stays in the page for screen readers, which do not get the list, so it is
  // read once. Whenever the reading is not certain the sentence stays exactly as it is: fewer than three
  // items, unbalanced brackets, a semicolon or a second sentence, a share left inside a name, two shares
  // for one item, a very long item, markup other than emphasis.
  var LIST_ATTR = "data-fm-list";
  var SHARE = "(?:[^\\s\\d.,()%]{1,7}\\.\\s*)?\\d+(?:[.,]\\d+)?\\s*%";
  var LEADING_SHARE = new RegExp("^(" + SHARE + ")\\s+");
  var TRAILING_SHARE = new RegExp("\\s+(" + SHARE + ")$");
  var ONLY_SHARE = new RegExp("^\\s*(" + SHARE + ")\\s*$");
  var ANY_SHARE = /\d\s*%/;
  var INLINE_TAGS = { STRONG: 1, B: 1, EM: 1, I: 1, U: 1, SPAN: 1, SUP: 1, SUB: 1, SMALL: 1, MARK: 1, ABBR: 1 };
  var MAX_NAME = 90;

  function isSpace(ch) {
    return ch !== "" && /\s/.test(ch);
  }

  // Start of the bracket group that ends at text[end - 1] (a ")"), or -1
  function groupStart(text, from, end) {
    var depth = 0;
    for (var i = end - 1; i >= from; i--) {
      var ch = text.charAt(i);
      if (ch === ")" || ch === "]") depth++;
      else if (ch === "(" || ch === "[") {
        depth--;
        if (depth === 0) return i;
      }
    }
    return -1;
  }

  // Items of a composition as offsets into its text: { name: [start, end], detail: [start, end] | null,
  // share: "32 %" | "" }, or null when the text is not a plain list. heading: the card's heading in lower
  // case; a label that repeats it, or its first words ("Složení: …" under "Složení a alergeny"), is no item.
  // Any other label in front of the list leaves the sentence as it is.
  function parseComposition(text, heading) {
    var start = 0;
    var end = text.length;
    var label = /^\s*([^:,()\d]{2,40}):\s+/.exec(text);
    if (label) {
      var labelText = label[1].replace(/^\s+|\s+$/g, "").toLowerCase();
      if (!heading || (heading !== labelText && heading.indexOf(labelText + " ") !== 0)) return null;
      start = label[0].length;
    }
    while (end > start && isSpace(text.charAt(end - 1))) end--;
    if (text.charAt(end - 1) === ".") end--;

    var ranges = [];
    var depth = 0;
    var from = start;
    var classAt = -1; // the item that names a class with a colon ("barvivo: E 120, E 160a")
    for (var i = start; i < end; i++) {
      var ch = text.charAt(i);
      if (ch === "(" || ch === "[") {
        depth++;
      } else if (ch === ")" || ch === "]") {
        depth--;
        if (depth < 0) return null;
      } else if (depth === 0) {
        if (ch === ";") return null;
        if (ch === ":") classAt = ranges.length;
        if (ch === "." && isSpace(text.charAt(i + 1))) {
          // "min. 50 %" goes on; a capital or a footnote mark after the full stop starts another sentence
          var next = text.slice(i + 1).replace(/^\s+/, "").charAt(0);
          if (next === "*" || next !== next.toLowerCase()) return null;
        }
        if (ch === "," && !(/\d/.test(text.charAt(i - 1)) && /\d/.test(text.charAt(i + 1)))) {
          ranges.push([from, i]);
          from = i + 1;
        }
      }
    }
    if (depth !== 0) return null;
    ranges.push([from, end]);
    if (ranges.length < 3) return null;
    // A class before other items may govern them ("sladidla: maltitol, sukralóza") or not ("emulgátor: lecitin, sůl"):
    // the text cannot tell, so the sentence stays. A class in the last item governs nothing else.
    if (classAt !== -1 && classAt < ranges.length - 1) return null;

    var items = [];
    for (var k = 0; k < ranges.length; k++) {
      var s = ranges[k][0];
      var e = ranges[k][1];
      while (s < e && isSpace(text.charAt(s))) s++;
      while (e > s && isSpace(text.charAt(e - 1))) e--;
      if (s === e) return null;

      var share = "";
      var detail = null;
      var lead = LEADING_SHARE.exec(text.slice(s, e));
      if (lead) {
        share = lead[1];
        s += lead[0].length;
      }
      // A share after the brackets: "bílá čokoláda (…) 25 %"
      var trail = TRAILING_SHARE.exec(text.slice(s, e));
      if (trail) {
        if (share) return null;
        share = trail[1];
        e -= trail[0].length;
      }
      // Brackets at the end: a share of their own "(32 %)" or what the ingredient is made of
      if (text.charAt(e - 1) === ")" || text.charAt(e - 1) === "]") {
        var open = groupStart(text, s, e);
        if (open > s) {
          var inner = ONLY_SHARE.exec(text.slice(open + 1, e - 1));
          if (inner) {
            if (share) return null;
            share = inner[1];
          } else {
            detail = [open + 1, e - 1];
            while (detail[0] < detail[1] && isSpace(text.charAt(detail[0]))) detail[0]++;
            while (detail[1] > detail[0] && isSpace(text.charAt(detail[1] - 1))) detail[1]--;
            if (detail[0] === detail[1]) detail = null;
          }
          e = open;
          while (e > s && isSpace(text.charAt(e - 1))) e--;
        }
      }
      // A share before the brackets: "bílá čokoláda 25 % (…)"
      trail = TRAILING_SHARE.exec(text.slice(s, e));
      if (trail) {
        if (share) return null;
        share = trail[1];
        e -= trail[0].length;
      }

      var name = text.slice(s, e);
      var outside = name;
      while (/\([^()]*\)|\[[^\[\]]*\]/.test(outside)) outside = outside.replace(/\([^()]*\)|\[[^\[\]]*\]/g, "");
      if (!name.replace(/\s+/g, "") || ANY_SHARE.test(outside) || outside.length > MAX_NAME) return null;
      items.push({ name: [s, e], detail: detail, share: share.replace(/\s+/g, "\u00a0") });
    }
    return items;
  }

  // The text nodes of an element with their offsets in its text
  function textNodes(root) {
    var walker = document.createTreeWalker(root, 4 /* NodeFilter.SHOW_TEXT */, null);
    var nodes = [];
    var position = 0;
    var node;
    while ((node = walker.nextNode())) {
      nodes.push({ node: node, start: position });
      position += node.data.length;
    }
    return nodes;
  }

  // A copy of the text between two offsets with the elements around it (an allergen in bold stays bold).
  // A range copies the elements it cuts through, not the ones that hold all of it: those are added here.
  function copyText(root, nodes, from, to) {
    var range = document.createRange();
    var set = 0;
    for (var i = 0; i < nodes.length && set < 3; i++) {
      var item = nodes[i];
      var length = item.node.data.length;
      if (!(set & 1) && from < item.start + length) {
        range.setStart(item.node, from - item.start);
        set |= 1;
      }
      if (set & 1 && to <= item.start + length) {
        range.setEnd(item.node, to - item.start);
        set |= 2;
      }
    }
    if (set !== 3) return null;

    var copy = range.cloneContents();
    var holder = range.commonAncestorContainer;
    if (holder.nodeType !== 1) holder = holder.parentNode;
    while (holder && holder !== root) {
      var shell = holder.cloneNode(false);
      shell.appendChild(copy);
      copy = shell;
      holder = holder.parentNode;
    }
    return copy;
  }

  function buildIngredientList(paragraph) {
    if (paragraph.hasAttribute(LIST_ATTR)) return;
    paragraph.setAttribute(LIST_ATTR, "");

    var inner = paragraph.querySelectorAll("*");
    for (var i = 0; i < inner.length; i++) {
      if (!INLINE_TAGS[inner[i].tagName]) return;
    }
    var card = paragraph.closest ? paragraph.closest(".fm-card") : null;
    var headingEl = card ? card.querySelector(".fm-card__heading") : null;
    var heading = headingEl ? headingEl.textContent.replace(/^\s+|\s+$|:\s*$/g, "").toLowerCase() : "";
    var items = parseComposition(paragraph.textContent, heading);
    if (!items) return;

    var nodes = textNodes(paragraph);
    var list = document.createElement("ul");
    list.className = "fm-ingredients-list";
    list.setAttribute("aria-hidden", "true");
    for (var k = 0; k < items.length; k++) {
      var item = items[k];
      var name = copyText(paragraph, nodes, item.name[0], item.name[1]);
      var detail = item.detail ? copyText(paragraph, nodes, item.detail[0], item.detail[1]) : null;
      if (!name || (item.detail && !detail)) return;

      var row = document.createElement("li");
      row.className = "fm-ingredients-list__item";
      var nameEl = document.createElement("span");
      nameEl.className = "fm-ingredients-list__name";
      nameEl.appendChild(name);
      row.appendChild(nameEl);
      if (item.share) {
        var shareEl = document.createElement("span");
        shareEl.className = "fm-ingredients-list__share";
        shareEl.textContent = item.share;
        row.appendChild(shareEl);
      }
      if (detail) {
        var detailEl = document.createElement("span");
        detailEl.className = "fm-ingredients-list__detail";
        detailEl.appendChild(detail);
        row.appendChild(detailEl);
      }
      list.appendChild(row);
    }
    // Copies of the sentence's elements must not repeat its ids
    Array.prototype.forEach.call(list.querySelectorAll("[id]"), function (el) {
      el.removeAttribute("id");
    });
    paragraph.parentNode.insertBefore(list, paragraph.nextSibling);
    paragraph.classList.add("fm-sr-only");
  }

  function initIngredients(root) {
    if (!document.createRange || !document.createTreeWalker) return;
    getScopedElements(root || document, ".fm-ingredients").forEach(function (paragraph) {
      try {
        buildIngredientList(paragraph);
      } catch (e) {
        // The sentence stays as it is
      }
    });
  }

  // A photo that fails to load is taken out together with its frame, so no empty box is left behind
  function hideBrokenPhoto(img) {
    var frame = img.closest ? img.closest("figure, .fm-founder__photo") : null;
    (frame || img).hidden = true;
  }

  function initPhotos(root) {
    getScopedElements(root || document, ".fm-desc").forEach(function (desc) {
      if (desc.hasAttribute(PHOTOS_ATTR)) return;
      desc.setAttribute(PHOTOS_ATTR, "");

      // "error" does not bubble, so it is caught on the way down
      desc.addEventListener(
        "error",
        function (event) {
          if (event.target && event.target.tagName === "IMG") hideBrokenPhoto(event.target);
        },
        true
      );

      Array.prototype.forEach.call(desc.querySelectorAll("img"), function (img) {
        if (img.complete && img.currentSrc && img.naturalWidth === 0) hideBrokenPhoto(img);
      });
    });
  }

  // Blocks that are entirely below the viewport when the observer first reports them get the hidden
  // state and lose it as soon as their first pixel scrolls into view. Everything else is left alone.
  function initReveal(root) {
    if (!("IntersectionObserver" in window)) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var blocks = getScopedElements(root || document, ".fm-animate").filter(function (el) {
      return !el.hasAttribute(REVEAL_ATTR);
    });
    if (!blocks.length) return;

    var observer = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;

        if (entry.isIntersecting) {
          el.classList.remove(REVEAL_CLASS);
          observer.unobserve(el);
        } else if (!el.classList.contains(REVEAL_CLASS)) {
          var box = entry.boundingClientRect;
          var viewport = entry.rootBounds;

          if (viewport && box.height > 0 && box.top >= viewport.bottom) {
            el.classList.add(REVEAL_CLASS);
          } else {
            observer.unobserve(el);
          }
        }
      });
    });

    blocks.forEach(function (el) {
      el.setAttribute(REVEAL_ATTR, "");
      observer.observe(el);
    });
  }

  function initFitMarDescriptions(root) {
    injectFounderBanner();
    initIngredients(root || document);
    initPhotos(root || document);
    initReveal(root || document);
  }

  window.FitMarDescriptions = { init: initFitMarDescriptions, parseComposition: parseComposition };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initFitMarDescriptions(document);
    });
  } else {
    initFitMarDescriptions(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initFitMarDescriptions(event.target || document);
  });
})();
